import React from 'react';
import AppPlatform from "types/AppPlatform";
import Card from "components/Card";
import {concatenate} from "services/string";
import Empty from "components/Empty";
import {DeviceMobileIcon, GlobeIcon} from "@heroicons/react/outline";
import {Icon} from "types/Icon";
import AppStatus from "types/AppStatus";

const headings: Record<AppPlatform, string> = {
    [AppPlatform.ANDROID]: "Android",
    [AppPlatform.HUAWEI]: "Huawei",
    [AppPlatform.IOS]: "iOS",
    [AppPlatform.WEB]: "Web",
}

const subheadings: Record<AppPlatform, string> = {
    [AppPlatform.ANDROID]: "Android mobile devices",
    [AppPlatform.HUAWEI]: "Huawei mobile devices",
    [AppPlatform.IOS]: "iOS mobile devices",
    [AppPlatform.WEB]: "Web browsers",
}

const icons: Record<AppPlatform, Icon> = {
    [AppPlatform.ANDROID]: DeviceMobileIcon,
    [AppPlatform.HUAWEI]: DeviceMobileIcon,
    [AppPlatform.IOS]: DeviceMobileIcon,
    [AppPlatform.WEB]: GlobeIcon,
}

const statements: Record<AppStatus, string> = {
    [AppStatus.PREPARING]: "Preparing",
    [AppStatus.REVIEW]: "In Review",
    [AppStatus.PUBLISHED]: "Published",
    [AppStatus.HIDDEN]: "Hidden",
}

const hintTemplates: Record<AppStatus, string> = {
    [AppStatus.PREPARING]: "This app is currently being prepared and will be submitted to {store} soon.",
    [AppStatus.REVIEW]: "This app has been submitted to {store} and is awaiting review.",
    [AppStatus.PUBLISHED]: "This app has been published to {store}.",
    [AppStatus.HIDDEN]: "This app has been published to {store}, but is currently hidden.",
}

const storeNames: Record<AppPlatform, string> = {
    [AppPlatform.ANDROID]: 'Play Store',
    [AppPlatform.HUAWEI]: 'AppGallery',
    [AppPlatform.IOS]: 'App Store',
    [AppPlatform.WEB]: '',
}

const hint = (platform: AppPlatform, status: AppStatus): string => {
    return hintTemplates[status].replace('{store}', storeNames[platform])
}

type Props = {
    platform: AppPlatform
    status?: AppStatus
}

function AppPlaceholder({platform, status}: Props) {
    return (
        <div className={concatenate(platform === AppPlatform.WEB && 'opacity-50 pointer-events-none')}>
            <Card
                heading={headings[platform]}
                subheading={subheadings[platform]}
                pingColour={status !== AppStatus.HIDDEN && platform !== AppPlatform.WEB && "brand"}
            >

                {!status &&
                    <Empty
                        icon={icons[platform]}
                        text="Coming soon..."
                        hint="Apps are not yet available for this platform"
                    />
                }

                {!!status &&
                    <Empty
                        icon={icons[platform]}
                        text={statements[status]}
                        hint={hint(platform, status)}
                    />
                }

            </Card>
        </div>
    );
}

export default AppPlaceholder;